/* abb-be.js (16 Oct 2026): arrows and the progress line for the homepage's
   sideways rows. Each press moves the row by one card (one column on the
   review wall). Arrows grey out at either end and hide when nothing scrolls.
   Arrows for a row are either inside the row's own wrapper, or anywhere on
   the page with data-be-arrows-for="<row id>" (the review wall). */
(function () {
  if (window.__abbBe2Init) return;
  window.__abbBe2Init = true;
  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-be-row]'), function (row) {
      var wraps = row.id ? Array.prototype.slice.call(document.querySelectorAll('[data-be-arrows-for="' + row.id + '"]')) : [];
      if (!wraps.length) { var own = row.parentNode.querySelector('[data-be-arrows]'); if (own) wraps = [own]; }
      var bar = row.id ? document.querySelector('[data-be-progress-for="' + row.id + '"]') : null;
      if (!wraps.length && !bar) return;
      function step() {
        var c = row.querySelector('li');
        var gap = parseFloat(getComputedStyle(row).columnGap) || 12;
        return c ? c.getBoundingClientRect().width + gap : row.clientWidth * 0.8;
      }
      function update() {
        var max = row.scrollWidth - row.clientWidth;
        wraps.forEach(function (w) {
          w.querySelector('[data-be-prev]').disabled = row.scrollLeft <= 2;
          w.querySelector('[data-be-next]').disabled = row.scrollLeft >= max - 2;
          w.hidden = max <= 2;
        });
        if (bar) {
          var seen = row.clientWidth / Math.max(row.scrollWidth, 1);
          bar.style.width = (Math.max(seen, 0.08) * 100) + '%';
          bar.style.transform = 'translateX(' + (max > 0 ? (row.scrollLeft / max) * ((1 - seen) / seen) * 100 : 0) + '%)';
        }
      }
      wraps.forEach(function (w) {
        w.querySelector('[data-be-prev]').addEventListener('click', function () { row.scrollBy({ left: -step(), behavior: 'smooth' }); });
        w.querySelector('[data-be-next]').addEventListener('click', function () { row.scrollBy({ left: step(), behavior: 'smooth' }); });
      });
      row.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
      row.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); row.scrollBy({ left: step(), behavior: 'smooth' }); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); row.scrollBy({ left: -step(), behavior: 'smooth' }); }
      });
      window.addEventListener('resize', update);
      update();
    });
  }
  /* The review wall: mark cards whose words are cut (so "Read the full
     review" shows only where it is true), and open any card in full in the
     review window, with Previous / Next through every review. */
  function initReviews() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-be-reviews]'), function (sec) {
      var cards = Array.prototype.slice.call(sec.querySelectorAll('[data-be-review]'));
      var dlg = sec.querySelector('[data-be-dialog]');
      if (!cards.length || !dlg) return;
      function markCut() {
        cards.forEach(function (c) {
          var q = c.querySelector('[data-be-quote]');
          c.classList.toggle('is-cut', q.scrollHeight > q.clientHeight + 2);
        });
      }
      var dq = dlg.querySelector('[data-be-dq]'), dn = dlg.querySelector('[data-be-dn]'), dd = dlg.querySelector('[data-be-dd]');
      var dpos = dlg.querySelector('[data-be-dpos]'), dprev = dlg.querySelector('[data-be-dprev]'), dnext = dlg.querySelector('[data-be-dnext]');
      var at = 0, opener = null;
      function show(i) {
        at = Math.max(0, Math.min(cards.length - 1, i));
        var c = cards[at];
        dq.textContent = '\u201C' + c.querySelector('[data-be-quote]').textContent.trim() + '\u201D';
        dn.textContent = c.querySelector('[data-be-name]').textContent.trim();
        var d = c.querySelector('[data-be-date]');
        dd.textContent = d ? d.textContent.trim() : '';
        dpos.textContent = 'Review ' + (at + 1) + ' of ' + cards.length;
        dprev.disabled = at === 0;
        dnext.disabled = at === cards.length - 1;
      }
      cards.forEach(function (c, i) {
        c.addEventListener('click', function () {
          opener = c;
          show(i);
          if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
          document.documentElement.style.overflow = 'hidden';
        });
      });
      function close() {
        if (typeof dlg.close === 'function') dlg.close(); else dlg.removeAttribute('open');
      }
      dlg.addEventListener('close', function () {
        document.documentElement.style.overflow = '';
        if (opener) { cards[at].focus(); cards[at].scrollIntoView({ block: 'nearest', inline: 'nearest' }); }
      });
      dlg.querySelector('[data-be-close]').addEventListener('click', close);
      dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
      dprev.addEventListener('click', function () { show(at - 1); });
      dnext.addEventListener('click', function () { show(at + 1); });
      dlg.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); show(at + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); show(at - 1); }
      });
      markCut();
      window.addEventListener('resize', markCut);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(markCut);
    });
  }
  function boot() { init(); initReviews(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
